import React, { useEffect } from "react";
import Header from "../components/Header";
import { getCanonicalUrl, setSeoTags } from "../utils/seo";

const offerText = `
на оказание информационных услуг по доступу к онлайн-сервису генерации бизнес-планов для программы «Социальный контракт» с использованием технологий искусственного интеллекта

Редакция от «28» июня 2026 г.

1. Общие положения

1.1. Настоящий документ является публичной офертой в соответствии со ст. 437 Гражданского кодекса РФ (далее — «Оферта») и адресован любому дееспособному лицу, индивидуальному предпринимателю или юридическому лицу (далее — «Пользователь»).

1.2. Лицом, оказывающим услуги, является Индивидуальный предприниматель Константинова Мария Дмитриевна, ИНН 661907098107, ОГРНИП 326965800156787, применяемая система налогообложения УСН, email: sotsplan@ya.ru, сайт: https://соц-план.рф (далее — «Исполнитель»).

1.3. Сведения о государственной регистрации Исполнителя: регистрирующий орган — Инспекция Федеральной налоговой службы по Верх-Исетскому району г. Екатеринбурга, адрес: 620014, г. Екатеринбург, ул. Хомякова, д. 4.

1.4. Принятие условий Оферты (акцепт) осуществляется путем последовательного совершения Пользователем конклюдентных действий: регистрации/авторизации на сайте https://соц-план.рф и/или оплаты выбранного тарифа/пакета услуг. С момента акцепта между Пользователем и Исполнителем заключается договор возмездного оказания услуг (далее — «Договор») на условиях Оферты (ст. 438 ГК РФ).

2. Термины и определения

2.1. Сервис — программно-аппаратный комплекс Исполнителя, доступный по адресу https://соц-план.рф и/или через мобильные приложения, предоставляющий Пользователю доступ к функционалу генерации текстовых материалов (в том числе бизнес-планов) с использованием технологий искусственного интеллекта (ИИ).

2.2. Материалы — текстовые и иные результаты, формируемые Сервисом по запросам Пользователя (включая бизнес-планы, описания проектов, расчётные таблицы, шаблоны, подсказки и т.п.).

2.3. Личный кабинет — раздел Сервиса, доступный Пользователю после авторизации.

2.4. Тариф — набор функционала и/или объёма использования Сервиса за плату по цене и на условиях, указанным на странице тарифов https://соц-план.рф/tariffs.

2.5. Повтор генерации — отдельная платная услуга по предоставлению Пользователю одной возможности сформировать новый вариант бизнес-плана. Каждый новый вариант сохраняется отдельно; стоимость и количество указываются до оплаты.

3. Предмет Договора

3.1. Исполнитель предоставляет Пользователю информационные услуги по предоставлению доступа к Сервису и его функционалу, а Пользователь обязуется оплачивать услуги в соответствии с выбранным Тарифом.

3.2. Услуги оказываются дистанционно, в информационно-консультационной форме, без выезда специалистов и без непосредственной проверки исходных данных Пользователя.

3.3. Исполнитель не оказывает юридических, бухгалтерских, финансовых, форензик- или иных лицензируемых услуг и не взаимодействует от имени Пользователя с органами государственной власти и организациями социальной защиты населения.

4. Важные оговорки и ответственность Пользователя

4.1. Материалы, создаваемые Сервисом, носят исключительно информационный и ознакомительный характер. Они не являются юридическим заключением, аудиторским отчётом, индивидуальной консультацией, государственной формой, обязательными требованиями или гарантией одобрения заявления на «Социальный контракт».

4.2. Условия предоставления мер поддержки по программе «Социальный контракт» устанавливаются нормативными актами субъектов РФ и могут различаться и изменяться. Пользователь обязуется самостоятельно проверять актуальность требований в своём регионе, корректность и полноту предоставляемых им данных и соответствие Материалов требованиям уполномоченных органов.

4.3. Пользователь несёт полную ответственность за выбор и применение Материалов, за принятие управленческих и правовых решений, за подготовку и подачу документов, а также за последствия их использования. Все риски и возможные убытки, связанные с использованием Материалов и исходных данных Пользователя, лежат на Пользователе.

4.4. Пользователь гарантирует, что обладает всеми необходимыми правами на предоставляемые в Сервис данные и контент, и что их передача/использование не нарушают прав третьих лиц и законодательства РФ.

5. Порядок оказания услуг и доступ

5.1. Доступ к Сервису предоставляется после регистрации/авторизации и, при платных Тарифах, после оплаты. Срок, объём квот, функционал и иные условия определяются выбранным Тарифом.

5.2. Услуга считается оказанной в момент предоставления Пользователю доступа к оплаченному функционалу Сервиса.

5.3. Исполнитель вправе проводить профилактические работы, обновления и иные мероприятия, временно ограничивающие доступ к Сервису, по возможности предварительно уведомляя Пользователей.

5.4. Исполнитель вправе в одностороннем порядке изменять функционал Сервиса, не снижая существенным образом объём уже оплаченных услуг на текущий оплаченный период.

6. Стоимость и расчёты

6.1. Стоимость услуг и условия Тарифов публикуются на https://соц-план.рф и включают все налоги, если иное не указано. Оплата производится безналично через доступные платёжные инструменты.

6.2. Моментом оплаты является подтверждение платёжной системой успешного проведения операции. После оплаты Исполнитель формирует кассовый чек с применением ККТ и направляет его на email, указанный Пользователем при оплате или регистрации, в порядке 54-ФЗ.

6.3. Повторы генерации приобретаются поштучно или в количестве, выбранном Пользователем до оплаты. Оплаченные возможности отражаются в Личном кабинете и расходуются при формировании нового варианта после исчерпания включённых в Сервис повторов генерации. Услуга по каждому повтору генерации считается оказанной в момент предоставления новой возможности либо, если она сразу использована, в момент запуска соответствующей генерации.

6.4. Подписка (если предусмотрена Тарифом) может автопродлеваться на следующий период на условиях Тарифа до её отключения Пользователем в Личном кабинете не позднее 24 часов до окончания оплаченного периода.

7. Права и лицензии

7.1. Все исключительные права на Сервис, программный код, дизайн, базы данных, бренд и иные объекты принадлежат Исполнителю и/или его правообладателям. Пользователю предоставляется неисключительная, непередаваемая лицензия на использование Сервиса в рамках выбранного Тарифа.

7.2. На Материалы, сгенерированные Сервисом по запросам Пользователя, Пользователю предоставляется неисключительное право использования для собственных целей, включая подачу документов в уполномоченные органы. Исполнитель не гарантирует уникальность и отсутствие совпадений с материалами иных пользователей или публичными источниками.

7.3. Запрещаются: обратная разработка Сервиса, обход технических ограничений, передача доступа третьим лицам, коммерческая перепродажа доступа без письменного согласия Исполнителя.

8. Персональные данные и конфиденциальность

8.1. Обработка персональных данных осуществляется в соответствии с Политикой в отношении обработки персональных данных Исполнителя https://соц-план.рф/policy и Федеральным законом № 152-ФЗ. Акцептуя Оферту, Пользователь подтверждает ознакомление с Политикой и даёт согласие на обработку персональных данных и получение сервисных сообщений.

8.2. Исполнитель принимает разумные и достаточные меры защиты, однако не гарантирует абсолютную безопасность при передаче данных через интернет-каналы. Пользователь обязуется не размещать в Сервисе сведения, распространение которых ограничено законом, без необходимого правового основания.

9. Ограничение ответственности

9.1. Сервис и Материалы предоставляются «как есть» (as is). В пределах, допускаемых законодательством РФ, Исполнитель не несёт ответственности за:
— соответствие Материалов ожиданиям Пользователя;
— любые решения, действия или бездействие Пользователя, принятые на основании Материалов;
— отказ, замечания или запросы органов власти/соцзащиты, а также за изменения нормативного регулирования;
— сбои работы интернета, платёжных систем, провайдеров, хостинга, а также форс-мажор.

9.2. Исполнитель не несёт ответственности за упущенную выгоду. Совокупная ответственность Исполнителя по любым требованиям ограничивается размером фактически уплаченной Пользователем стоимости услуг за последний оплаченный период, если иное не предусмотрено императивными нормами закона.

9.3. Никакие рекомендации и подсказки Сервиса не являются юридической, бухгалтерской или иной профессиональной консультацией.

10. Права и обязанности сторон

10.1. Пользователь обязуется:
— предоставлять достоверные данные, необходимые для оказания услуг;
— соблюдать законодательство РФ и условия Оферты;
— самостоятельно проверять актуальные требования к документам по программе «Социальный контракт» в своём регионе;
— не нарушать права третьих лиц.

10.2. Исполнитель обязуется:
— предоставлять доступ к Сервису в объёме и на условиях выбранного Тарифа;
— обрабатывать обращения Пользователей по каналам поддержки: e-mail, web-сайт;
— выставлять кассовые чеки в установленном порядке.

11. Отказ от услуг и возвраты

11.1. Пользователь — потребитель вправе отказаться от исполнения Договора в любое время при условии оплаты Исполнителю фактически понесённых расходов (ст. 32 Закона РФ «О защите прав потребителей» № 2300-1).

11.2. Возвраты средств (если применимо) осуществляются по письменному обращению Пользователя на sotsplan@ya.ru с указанием причины и данных платежа. При предоставлении доступа к цифровому контенту и (или) оказании части услуг возврат производится с учётом удержания стоимости фактически оказанных услуг и понесённых расходов.

11.3. Для Тарифов с автопродлением возвраты за уже начавшийся новый период, как правило, не производятся при несвоевременном отключении автопродления Пользователем, если иное прямо не указано в условиях Тарифа или не вытекает из закона.

12. Досудебный порядок и разрешение споров

12.1. Претензионный порядок обязателен. Претензия направляется на sotsplan@ya.ru. Срок ответа — 10 (десять) рабочих дней с даты получения.

12.2. Споры подлежат рассмотрению в суде по месту нахождения Исполнителя с учётом правил подсудности и гарантий, предусмотренных законодательством о защите прав потребителей, если Пользователь является потребителем. Применимое право — материальное право Российской Федерации.

13. Изменение и расторжение Оферты

13.1. Исполнитель вправе изменять Оферту и Тарифы, публикуя новую редакцию на сайте с указанием даты вступления в силу. Использование Сервиса после вступления изменений в силу означает согласие Пользователя с изменениями.

13.2. Исполнитель вправе прекратить доступ Пользователя к Сервису при нарушении условий Оферты, прав третьих лиц или требований закона, уведомив Пользователя по указанным контактам, если это возможно.

14. Форс-мажор

14.1. Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств, вызванное обстоятельствами непреодолимой силы (форс-мажор), которые Стороны не могли предвидеть или предотвратить разумными мерами (включая, но не ограничиваясь: акты госорганов, сбои глобальных сетей, отключения электроэнергии, войны, эпидемии и т.п.). Сторона, ссылающаяся на форс-мажор, обязуется своевременно уведомить другую Сторону.

15. Заключительные положения

15.1. Недействительность отдельного положения Оферты не влечёт недействительность Оферты в целом.

15.2. Все уведомления могут направляться в электронном виде (в Личном кабинете и/или на e-mail). Электронные документы и лог-записи Сервиса признаются надлежащими доказательствами объёма оказанных услуг.

15.3. Языком Оферты и переписки является русский.

15.4. Акцептуя Оферту, Пользователь подтверждает, что внимательно ознакомился с её условиями, Политикой конфиденциальности, Тарифами и принимает их в полном объёме.

Реквизиты Исполнителя

Наименование: Индивидуальный предприниматель Константинова Мария Дмитриевна
ИНН: 661907098107
ОГРНИП: 326965800156787
Система налогообложения: УСН
Регистрирующий орган: Инспекция Федеральной налоговой службы по Верх-Исетскому району г. Екатеринбурга
Адрес регистрирующего органа: 620014, г. Екатеринбург, ул. Хомякова, д. 4
E-mail: sotsplan@ya.ru
Сайт: https://соц-план.рф`;

export default function OfferPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    setSeoTags({
      title: "СоцПлан | Публичная оферта",
      description:
        "Публичная оферта сервиса СоцПлан с условиями оказания информационных услуг по генерации бизнес-планов для социального контракта.",
      url: getCanonicalUrl("/offer"),
    });
  }, []);

  const paragraphs = offerText.split("\n\n");

  return (
    <div className="min-h-screen bg-slate-100 py-6 md:py-10">
      <div className="mx-auto w-full max-w-5xl rounded-2xl border bg-white shadow-md">
        <Header
          navigate={navigate}
          user={user}
          onLogin={onLogin}
          onAccount={onAccount}
          showBlog={showBlog}
          onShareSite={onShareSite}
        />
        <section className="px-5 md:px-6 py-6 space-y-4 text-slate-700">
          <h1 className="text-2xl font-bold mb-4">Публичная оферта</h1>
          {paragraphs.map((text, idx) => {
            const trimmed = text.trim();
            if (/^\d+\.\s/.test(trimmed)) {
              return (
                <h2 key={idx} className="text-xl font-bold mt-6">
                  {trimmed}
                </h2>
              );
            }
            return <p key={idx} className="whitespace-pre-line">{trimmed}</p>;
          })}
        </section>
      </div>
    </div>
  );
}
